import { UserRound } from 'lucide-react';
import type { PatientPhysicianViewModel } from '@generated';

export function PhysicianRowLabel({ patientPhysician, notes }: { patientPhysician: PatientPhysicianViewModel; notes?: string }) {
	return (
		<div className="flex items-center gap-2">
			<UserRound size={14} className="shrink-0 text-gray-400" />
			<div>
				<p className="text-sm font-medium text-gray-900">{patientPhysician.physician.fullName}</p>
				<p className="text-xs text-gray-500">
					NPI: {patientPhysician.physician.npiNumber}
					{patientPhysician.patientPhysicianAssociationLabel}
				</p>
				{notes && <p className="text-xs italic text-gray-500">{notes}</p>}
			</div>
		</div>
	);
}
